import { Card, Typography } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { putData } from "../../../actions/developer";
import { checkAuth } from "../../../actions/auth";
const { Title, Text } = Typography;

const SummaryCard = () => {
    const { user } = useSelector((state: any) => state.app);
    const dispatch = useDispatch();

    const updateSummary = async (value: string, key: string) => {
        console.log(value, key);
        const resData = dispatch(putData(`/users/${user?._id}`, { [key]: value }));
        if (resData) {
            await dispatch(checkAuth());
        }
    };

    return (
        <>
            <Card style={{ width: '100%' }}>
                <Title level={4}>Introduction Summary</Title>
                <div>
                    <Title level={5}>Bio</Title>
                    <Text type='secondary' editable={{
                        onChange: (value) => updateSummary(value, 'bio')
                    }}>{user?.bio}</Text>
                </div>
                <div>
                    <Title level={5}>What I Love In My Job ?</Title>
                    <Text type='secondary' editable={{
                        onChange: (value) => updateSummary(value, 'whatILoveInMyJob')
                    }}>{user?.whatILoveInMyJob}</Text>
                </div>
                <div>
                    <Title level={5}>My Interests & Hobbies</Title>
                    <Text type='secondary' editable={{
                        onChange: (value) => updateSummary(value, 'myIntrestAndHobbies')
                    }}>{user?.myIntrestAndHobbies}</Text>
                </div>
            </Card>
        </>
    );

}

export default SummaryCard;